import React, {useEffect, useState} from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress'
import {
    apollo_theme,
    apollo_useStyles,
    Copyright,
} from "../../atom/Apollo_styles";

import {ApolloContext} from "../../atom/Apollo_Context";
import {
    signin_api,
    home_path,
} from "../../atom/Apollo_links";

import {CustomizedSnackbars, ApolloMessage } from "../../atom/Apollo_Mesasge";

import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';

import {useForm} from "react-hook-form";
import {useHistory, useLocation} from "react-router-dom";
import {ApolloAxios,apimessageMap} from "../../atom/Apollo_ApiRequest3";
import {ThemeProvider} from "@material-ui/styles";
import { ApolloAccount } from "../../atom/Apollo_Account";
import { ApolloPassword } from "../../atom/Apollo_Password" ;
import ResigninDialog from "./ReSignIn";

import {ApolloEventRecord, LogData,ItemList} from "../../atom/Apollo_EventRecord";
import moment from "moment";
import { Typography, Box } from '@material-ui/core';

const SignInPage: React.FC = () => {

    const classes = apollo_useStyles();
    let history = useHistory();
    const { register,handleSubmit, errors } = useForm<FormData>();
    const { state, dispatch} = React.useContext(ApolloContext)
    const { setmsg } = React.useContext(ApolloMessage) ;
    const [ resign, setParam] = useState(  {open:false, email:"",onetimeToken:""} );

    const [ passinit,setParamInit ] = useState(process.env.REACT_APP_AROHA_PASSWORD_INIT);
    const [ , setParamMod ] = useState(process.env.REACT_APP_AROHA_PASSWORD_MODIFY );
    const userPolicyPdfUrl = process.env.REACT_APP_USER_POLICY_PDF_URL;

    useEffect(() => {
        setParamInit(process.env.REACT_APP_AROHA_PASSWORD_INIT)
        setParamMod(process.env.REACT_APP_AROHA_PASSWORD_MODIFY)
    },[]);

    const [bdopen, setbdOpen] = React.useState(false);
    const bdhandleClose = () => {
        setbdOpen(false);
    };
    const bdhandleToggle = () => {
        setbdOpen(!bdopen);
    };

    // GET クエリーストリングの取得
    let query = new URLSearchParams(useLocation().search) ;

    //　認証トークンがある場合はチェック
    if ( query.has("authtoken") ) {
        //Token Check (API)
        siginredirect();
    }

    const handleClose = () => {
        setParam({open:false, email:"",onetimeToken:""} );
    };

    //　リダイレクトパスがある場合は、認証後遷移
    function  siginredirect( )  {
        let path =  home_path;
        if ( query.has("redirect") ) {
            let work = query.get("redirect") ;
            if (work != null) path = work ;
        }
        //redirect パラメータがない場合は、サマリーへ
        history.push( path );
    }

    //sign-in　ボタンをクリック時処理
    const onSubmit = handleSubmit(async ( data : any ) => {

        console.log("Analytics start:")
        const itemList: ItemList[] = [
            {
                key: "サインインメールアドレス",
                beforeValue:  "" ,
                afterValue:  data.email,
            }
        ]
        const logTime = moment().format("YYYY-MM-DD HH:mm:ss");
        const executionLog: LogData = {
            eventDate: logTime, // イベント日時 “YYYY-MM-DD HH:MM:SS“ 形式
            logType: "execute",// ログ種別 実行：execute, 結果：result
            result: "",
            userID: state.userprofile.userId,// ユーザID
            userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
            accessToken: state.accesstoken, // APIアクセス用トークン
            accountGroupID: state.current.accountGroupId, // アカウントグループID
            accountGroupName: state.current.accountGroupName, // アカウントグループ名
            accountID: state.current.accountId, // 広告主アカウントID
            accountName: state.current.accountName, // 広告主アカウント名
            campaignID: "", // キャンペーンID
            campaignName: "", // キャンペーン名
            adGroupID: "", // 広告グループID
            adGroupName: "", // 広告グループ名
            menu: "", // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
            displayName: "サインイン画面", // 操作画面名称 〇〇画面
            category: "認証", // 操作対象 キャンペーン / セグメント etc...
            actionType: "サインイン" , // アクション 参照 / 作成 / 更新 / 削除 / アップロード
            targetID: "",
            targetName: "",
            itemList: itemList,
        }

        ApolloEventRecord(executionLog);

        const urlstring = signin_api;
        bdhandleToggle()
        //Ajax コール
        ApolloAxios.post( urlstring , {
                email: data.email,
                password: data.password
            }).then( response => {
                //Body に付与される認可情報などをContextへセット
                if ( response.data.resultCode === 20001 || response.data.resultCode === 20002 ) {
                    //console.log(response.data.resultCode)
                    setParam({open: true, email: data.email, onetimeToken: response.data.onetimeToken});
                } else {

                    if ( response.data.userprofile.userId === 0 ) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...data,
                                open: apimessageMap[5].open,
                                type: apimessageMap[5].type,
                                message: apimessageMap[5].msg
                            }});
                    }
                    else {
                        dispatch({
                            type: "setAccount",
                            payload: {
                                ...state,
                                userprofile: response.data.userprofile,
                                authorization: response.data.authorization,
                                current: response.data.current,
                                apolloList: response.data.apolloList,
                                accesstoken: response.data.accesstoken,
                            }
                        });

                        const resultLog: LogData = {
                            ...executionLog,
                            eventDate: moment().format("YYYY-MM-DD HH:mm:ss"), // イベント日時 “YYYY-MM-DD HH:MM:SS“ 形式
                            logType: "result",// ログ種別 実行：execute, 結果：result
                            result: "成功",
                            userID: response.data.userprofile.userId,// ユーザID
                            userName: response.data.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
                            accountGroupID: response.data.current.accountGroupId?? 0, // アカウントグループID
                            accountGroupName: response.data.current.accountGroupName, // アカウントグループ名
                            accountID: response.data.current.accountId?? 0, // 広告主アカウントID
                            accountName: response.data.current.accountName, // 広告主アカウント名
                        }
                        ApolloEventRecord(resultLog);

                        siginredirect();
                    }
                }
            })
            .catch(function (error) {
                bdhandleClose()
                setmsg({
                        type: "all",
                        payload: {
                            ...data,
                            open: error.open,
                            type: error.type,
                            message: error.errmsg,
                            loading: false
                        }
                });
                if (error.redirect !== "") {
                    const url = error.redirect ;
                    history.push( url );
                }
              });
    });

    // @ts-ignore
    return (
    <ThemeProvider theme={apollo_theme}>
        <div className={classes.square}></div>
        <Container maxWidth="xl" className={classes.signinpaper}>
            <Grid item xs={5}  alignItems="center" justify="center">
                <img src={`/logo/${process.env.REACT_APP_ENV}/logo_docomo.png`} alt="Apollo" height="32" width="auto"  />
            </Grid>
        </Container>
        <Container component="main" maxWidth="xs" className={classes.signinpaper}>
        <React.Fragment >
            <Grid container spacing={2}  alignItems="center" justify="center">
            </Grid>
          <form className={classes.form} noValidate>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <ApolloAccount register={register}  errors={errors} />
                </Grid>
                <Grid item xs={12}>
                    <ApolloPassword register={register}
                                    errors={errors}
                                    id={"password"}
                                    name={"password"}
                                    label={"パスワード"}/>
                    <Typography variant='caption' color='textSecondary'>
                        ※一部のブラウザでは、パスワードなどのフォーム入力値を強制的に保存する場合があります。<br/>
                        　共用端末ではパスワードなどを入力しないことを推奨いたします。
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={onSubmit}
                >
                    サインイン
                </Button>
                </Grid>
                <Grid item xs>
                </Grid>
                <Grid item>
                    <Link href={ passinit } variant="body2" color="textSecondary" target="_passinit" >
                      パスワード初期化
                    </Link>
                </Grid>
                <Grid container item xs={12} justify="flex-end">
                    <Link
                        href={userPolicyPdfUrl}
                        variant="body2"
                        color="textSecondary"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        利用規約
                    </Link>
                </Grid>
            </Grid>
          </form>
        </React.Fragment>
        <Backdrop className={classes.backdrop} open={bdopen} onClick={bdhandleClose}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CustomizedSnackbars/>
          <ResigninDialog  open={resign.open} email={resign.email} onetimeToken={resign.onetimeToken} handleClose={handleClose} />
        </Container>
        <Grid container xs={12} alignItems="center" justifyContent="center" style={{marginTop: "32px"}}>
          <Link href={process.env.REACT_APP_CONNECTING_PASS} target='_blank' style={{width:"580px"}}>
            <img src={`/banner_connecting_pass.png`} width="100%" style={{border:"1px solid rgb(204, 0, 51)"}}/>
          </Link>
        </Grid>
        <Box mt={"32px"}>
            <Copyright />
        </Box>
    </ThemeProvider>
  );
};
// @ts-ignore
export default SignInPage;
